import { sessionId } from '_legacy/api/session';
import { authenticationService } from '_legacy/auth/AuthenticationService';
import { apiBaseUrl } from '_legacy/config';
import { useEffect, useState } from 'react';

const HealthPage: React.FC = () => {
    const [healthResponse, setHealthResponse] = useState('Loading...');

    useEffect(() => {
        fetch(`https://${apiBaseUrl}/health`, {
            headers: {
                Authorization: encodeURIComponent(
                    authenticationService.getAccessToken()
                ),
                fortSessionId: sessionId,
            },
        })
            .then((response) => response.json())
            .then((json) => setHealthResponse(JSON.stringify(json, null, 4)));
    }, []);

    return (
        <div style={{ whiteSpace: 'pre', font: 'Roboto', lineHeight: 1 }}>
            {healthResponse}
        </div>
    );
};

export default HealthPage;
